// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalAlignTopOutlinedSvg from "@ant-design/icons-svg/es/asn/VerticalAlignTopOutlined";
import AntdIcon from '../components/AntdIcon';

var VerticalAlignTopOutlined = function VerticalAlignTopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignTopOutlinedSvg
  }));
};

VerticalAlignTopOutlined.displayName = 'VerticalAlignTopOutlined';
export default /*#__PURE__*/React.forwardRef(VerticalAlignTopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/VerticalAlignTopOutlined.js
// module id = 650
// module chunks = 0